import { InputContainer } from 'components/inputContainer/inputContainer';

import template from './giftCardLineItem.html';
import './giftCardLineItem.scss';

export const GiftCardLineItem = angular
    .module('checkout.components.orderSummary.giftCardLineItem', [
        InputContainer
    ]).component('giftCardLineItem', {
        template,
        bindings: {
            appliedStoreCredit: '<'
        },
        controller: class GiftCardLineItemCtrl {
            $onInit() {
                const giftCardCode = this.appliedStoreCredit.giftCardCode;
                this.giftCardName = `****${giftCardCode.slice(giftCardCode.length - 4).toUpperCase()}`;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/orderTotals/giftCardLineItem.js